module.exports = __webpack_public_path__ + "static/media/arrow.0c1b55d9.svg";